export class AppConstants {
    static defaultErrorNotificationTimeoutMs = 5000;
    static study = 'Studies';
    static username = 'Username';
    static email = 'Email';
    static isEnterpriseUser = 'IsEnterpriseUser';
    static roles = 'Roles';
    static sites = 'Sites';
    static studyTemplatename = 'study';
    static roleTemplatename = 'role';
    static siteTemplatename = 'site';
}
